export const SECTION_COMPLEMENTARIES = 'SECTION_COMPLEMENTARIES'
